module.exports = __webpack_public_path__ + "hehe.214bffa3.png";